!(function () {
    "use strict";
    new (class {
        constructor() {
            this.url = $(".search-btn[data-url]").data("url");
            $(".search-btn").Flyout({
                id: "searchFlyout",
                changeIds: !1,
                zindex: 2e3,
                content: { type: "url", copyType: "append", src: wpApiSettings.root + "goodyearforward/v1/" + this.url },
                position: [
                    { breakpoint: "sm", position: "top", size: "65%" },
                    { breakpoint: "md", position: "top", size: "818px" },
                    { breakpoint: "lg", position: "top", size: "492px" },
                ],
                showLogo: !0,
                destroyOnClose: !0,
                onComplete: function (a) {
                    a.addClass("row"),
                        a.find(".search").removeClass("d-none"),
                        a.find(".search-field").focus(),
                        new (class {
                            constructor(a) {
                                (this.inputField = $('form[name="simpleSearch"] input.search-field')), this.inputTimer, (this.contentElement = a), this.previousvalue, (this.suggestionWrapper = this.contentElement.find(".suggestions-wrapper")), this.events();
                            }
                            events() {
                                this.inputField.on("keyup", this.keyDownDebounce.bind(this));
                            }
                            keyDownDebounce(a) {
                                this.inputField.val() != this.previousvalue &&
                                    (clearTimeout(this.inputTimer),
                                    this.inputField.val() && this.inputField.val().length >= 3
                                        ? (this.contentElement.find(".flyloader").removeClass("d-none"), (this.inputTimer = setTimeout(this.getResults.bind(this), 500)))
                                        : (this.suggestionWrapper.html(""),
                                          this.contentElement.find(".popular-searches").hasClass("d-none") && this.contentElement.find(".popular-searches").removeClass("d-none"),
                                          !this.contentElement.find(".flyloader").hasClass("d-none") && this.contentElement.find(".flyloader").addClass("d-none"))),
                                    (this.previousvalue = this.inputField.val());
                            }
                            getResults() {
                                this.contentElement.find(".popular-searches").addClass("d-none");

                                $.ajax({
                                    url: wpApiSettings.root + "goodyearforward/v1/search?term=" + this.inputField.val(),
                                    method: "GET",
                                    contentType: "application/json",
                                    dataType: "json",
                                    beforeSend: function (xhr) {
                                        xhr.setRequestHeader("X-WP-Nonce", wpApiSettings.nonce);
                                    },
                                    success: (response) => {
                                        const results = response.data;
                                        this.contentElement.find(".flyloader").addClass("d-none");
                                        if (!results.content.length && !results.categories.length && !results.tires.length) {
                                            this.contentElement.find(".popular-searches").hasClass("d-none") && this.contentElement.find(".popular-searches").removeClass("d-none");
                                            this.suggestionWrapper.html("");
                                        } else {
                                            const val = this.inputField.val();
                                            var regex = new RegExp(val, "gi");
                                            const contentSection = `
                                            <ul class="similar-suggestions" role="list">
                                                ${results.categories.length ? `<li class="header item">${wp_goodyear.categories}</li>` : ""}
                                                ${results.categories
                                                    .map((item, index) => {
                                                        if (index <= 4) {
                                                            return `<li class="item" id="category-${index}">
                                                                        <a href="${item.permalink}" class="ellipsis meganav-link-programmatic text-uppercase" role="listitem" data-qa-id="search-category-null">                         
                                                                        <span class="name">${item.title.replace(regex, function (match) {
                                                                            return '<span class="highlight">' + match + "</span>";
                                                                        })}</span>
                                                                        </a>
                                                                    </li>`;
                                                        }
                                                        return "";
                                                    })
                                                    .join("")}
                
                                                ${results.content.length ? `<li class="header item">${wp_goodyear.contents}</li>` : ""}
                                                ${results.content
                                                    .map((item, index) => {
                                                        if (index <= 4) {
                                                            return `
                                                            <li class="item" id="content-${index}">
                                                                <a href="${item.permalink}" class="ellipsis meganav-link-programmatic text-uppercase" role="listitem" data-qa-id="search-category-null">                         
                                                                <span class="name">${item.title.replace(regex, function (match) {
                                                                    return '<span class="highlight">' + match + "</span>";
                                                                })}</span>
                                                                </a>
                                                            </li>   
                                                            `;
                                                        }
                                                        return "";
                                                    })
                                                    .join("")}
                                            </ul>
                                            `;
                                            this.suggestionWrapper.html(`
                                                <div class="suggestions container list-and-grid-container" id="search-results">
                                                    
                                                    <div class="product-sugesstions highlight-section">
                                                    <div class="header item">
                                                    ${results.tires.length ? wp_goodyear.products : ""}
                                                    </div>                 
                                                    
                                                    ${results.tires
                                                        .map((item, index) => {
                                                            if (index < 3) {
                                                                return `
                                                            <div class=" item product-card default product-analytics " id="product-null">
                                                            <a href="${item.permalink}" aria-label="${item.title}" class="product-card-container mt-0">
                                                                <img class="swatch-circle hidden-xs-down mb-16" alt="Product thumbnail image for ${item.title}" src="${item.thumbnail}" data-qa-id="search-product-card-img">
                                                                <div class="ellipsis">
                                                                    <span class="brand-name text-uppercase" data-qa-id="search-product-card-brand-name">Goodyear</span>
                                                                    <span class="product-name line-clamp-3 text-uppercase" data-qa-id="search-product-card-product-name">${item.title}</span>
                                                                </div>
                                                            </a>
                                                            </div>`;
                                                            }
                                                            return "";
                                                        })
                                                        .join("")}
                                                    </div>
                                                </div>
                                            
                                                `);

                                            if (!results.content.length && !results.categories.length) {
                                                this.suggestionWrapper.find("#search-results").addClass("full-column");
                                            } else {
                                                this.suggestionWrapper.find("#search-results").prepend(contentSection);
                                            }
                                        }
                                    },
                                });
                            }
                            initialState() {}
                        })(a);
                },
            });
        }
    })();
})();
